import { render, staticRenderFns } from "./PagePath.vue?vue&type=template&id=57a5b18a&"
import script from "./PagePath.vue?vue&type=script&lang=ts&"
export * from "./PagePath.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports